import { FC, useRef } from 'react';
import { useOutsideClick } from '@/hooks/outsideClick/outsideClick.hook';
import IconTriangle from '@/assets/svg/img_triangle_white.svg?react';
import Overlay from '@/components/elems/Overlay/Overlay.component';
import styles from '@/components/interactive/DropDownMenu/DropDownMenu.module.scss';
import { DropDownMenuIF } from '@/components/interactive/DropDownMenu/DropDownMenu.types';

const DropDownMenu: FC<DropDownMenuIF> = ({ children, position, onClose }) => {
    const menuRef = useRef<HTMLDivElement | null>(null);

    useOutsideClick(menuRef, onClose);

    return (
        <Overlay>
            <div ref={menuRef} className={`flcol ${styles.dropDownMenu}`}>
                {children}
                {position ? (
                    <IconTriangle className={styles[`arrow${position}`]} />
                ) : null}
            </div>
        </Overlay>
    );
};
export default DropDownMenu;
